exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gift_card_trace_pane[data-v-3696a9f9]{\n  padding: 0;\n}\n.card-info[data-v-3696a9f9]{\n  margin-bottom: 24px;\n}\n.circulation-log h4[data-v-3696a9f9]{\n  margin-bottom: 12px;\n  font-size: 15px;\n  font-weight: 600;\n}\n.empty-tip[data-v-3696a9f9]{\n  text-align: center;\n  color: #999;\n  padding: 40px 0;\n  font-size: 14px;\n}\n", ""]);

// exports
